module.exports = __webpack_public_path__ + "img/girl_usa.235ef3ff.png";